/* This example requires Tailwind CSS v2.0+ */
import { Popover } from '@headlessui/react'
// import WalletCard from './WalletCard'

export default function Header() {
  return (
    <Popover className="relative bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="flex justify-between items-center border-b-2 border-gray-100 py-6 md:justify-start md:space-x-10">
          <div className="flex justify-start lg:w-0 lg:flex-1">
            <a href="/">
              <span className="sr-only">A Monk's Art</span>
              <img
                className="h-20 w-auto sm:h-20"
                src="logo192.png"
                alt=""
              />
            </a>
          </div>
        </div>
      </div>


    </Popover>
  )
}
